// extracted by mini-css-extract-plugin
export var circle = "_fy-1";
export var exitConfirmationModal = "_fy-5";
export var iframe = "_fy-0";
export var offline = "_fy-3";
export var online = "_fy-2";
export var workstationSelectError = "_fy-4";